import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUser } from '@interfaces/IUser';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfileChangesService {
  constructor(private _http: HttpClient) {}

  edit(
    id: number,
    userData: IUser
  ): Observable<{ user: IUser; detail: string }> {
    const url = `${environment.baseUrl}api/v1/users/${id}/`;
    return this._http.put<{ user: IUser; detail: string }>(url, userData);
  }

  editAvatar(
    newUserData: FormData
  ): Observable<{ detail: string; url: string }> {
    const url = `${environment.baseUrl}api/v1/users/upload-avatar/`;
    return this._http.put<{ detail: string; url: string }>(url, newUserData);
  }
}
